import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics, BaseModel } from '../../libraries';
import { createUserModel } from './userInfo';
export class SignupController {
    constructor() {
        this.Model = new BaseModel({
            type: 'object',
            storageLoading: false,
        });
        //用户数据
        this.UserInfo = createUserModel();
    }
    get liveId() {
        return lodash.get(this.UserInfo.value, 'liveId');
    }
    get userCode() {
        return lodash.get(this.UserInfo.userInfo, 'userCode');
    }
    get userName() {
        return lodash.get(this.UserInfo.userInfo, 'userName', '游客');
    }
    get page_before() {
        return lodash.get(this.Model.value, 'page_before');
    }
    get page_in() {
        return lodash.get(this.Model.value, 'page_in');
    }
    get isSignBefore() {
        return lodash.get(this.page_before, 'isSign', false);
    }
    get isSignIn() {
        return lodash.get(this.page_in, 'isSign', false);
    }
    //前置问卷是否开启
    get isStatusBefore() {
        return lodash.eq(lodash.get(this.page_before, 'status'), 1);
    }
    //内置问卷是否开启 0 表示未开启 1 表示 已开启
    get isStatusIn() {
        return lodash.eq(lodash.get(this.page_in, 'status'), 1);
    }
    //是否已经填写过问卷
    isfilledQuestion(signupId) {
        return AjaxBasics.request(lodash.assign({}, EnumAPI.live_questionnaire_check, {
            body: {
                liveId: this.liveId,
                userCode: this.userCode,
                questionnaireId: signupId,
            },
        }));
    }
    async getSignupState(data, type = 'page_before') {
        try {
            const curForm = lodash.head(data[type]);
            if (curForm) {
                const res = await this.isfilledQuestion(curForm.question_id);
                this.Model.merge({
                    [type]: lodash.assign({}, curForm, { isSign: res }),
                });
            }
            else {
                this.Model.merge({
                    [type]: lodash.assign({}, curForm, { isSign: true }),
                });
            }
        }
        catch (error) { }
    }
    onSignUpLog(signupId) {
        try {
            AjaxBasics.request(lodash.assign({}, EnumAPI.live_questionnaire_save, {
                body: {
                    liveId: this.liveId,
                    userCode: this.userCode,
                    questionnaireId: signupId,
                },
            }));
        }
        catch (error) { }
    }
    //获取当前频道正在使用的问卷数据
    onGetSignupInfo() {
        return new Promise((resolve, reject) => {
            Mudu.Room.Signup.GetUsingSignup((dataStr) => {
                // data 数据结果如下表所示
                const data = JSON.parse(dataStr);
                if (lodash.eq(data.errcode, 1000)) {
                    resolve(data);
                }
                reject(data);
            });
        });
    }
    onSignUpListener() {
        // 监听问卷的使用状态变更， 需要在频道初始化完成后调用
        Mudu.MsgBus.On('Signup.Status.Change', async (dataStr) => {
            const data = JSON.parse(dataStr);
            if (lodash.eq(data.position, 0)) {
                //  0表示内置问卷；1表示前置问卷
                const res = await this.onGetSignupInfo();
                this.getSignupState(res, 'page_in');
                this.Model.merge({
                    page_in: lodash.assign({}, this.page_in, {
                        status: data.status ? 1 : 0,
                    }),
                });
            }
            else {
                this.Model.merge({
                    page_before: lodash.assign({}, this.page_before, {
                        status: data.status ? 1 : 0,
                    }),
                });
            }
        });
    }
    //提交表单数据
    onSignUpSimbit(columns, id, type) {
        return new Promise(async (resolve, reject) => {
            Mudu.Room.Signup.SubmitSingup({
                // code: '8909', // 必须 string 手机验证码，若无，则为空字符串 先不要
                signupId: id,
                columns,
            }, (response) => {
                response = JSON.parse(response);
                if (response.errcode == 1000) {
                    this.onSignUpLog(id);
                }
                // response 中对应的错误码见页面底部
                if (response.errcode == 1000 ||
                    response.errcode == 5627 ||
                    response.errcode == 5620) {
                    //填写问卷成功 or 已填写过问卷 or 已关闭问卷
                    this.Model.merge({
                        [type]: lodash.assign({}, this[type], { isSign: true }),
                    });
                    resolve(lodash.assign({}, response, {
                        msg: response.errcode == 1000 ? '提交成功' : response.msg,
                    }));
                }
                reject(response);
            });
        });
    }
    async onInitSignUp() {
        try {
            if (this.userCode) {
                const res = await this.onGetSignupInfo();
                await this.getSignupState(res, 'page_before');
                await this.getSignupState(res, 'page_in');
            }
        }
        catch (error) { }
    }
}
